export const responsibleOptions = [
  "Benchtop",
  "Building",
  "CNC",
  "Chassis",
  "Chassis Prep",
  "Damaged",
  "Decal",
  "Doors & Drawers",
  "Electrical",
  "Finishing",
  "Furniture",
  "Planning",
  "Plumbing",
  "Roof Prep",
  "Sealing",
  "Splashback",
  "Stock",
  "Supplier",
  "Wall Prep",
];
